import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Site } from 'src/app/model/site';
import { AppState } from 'src/app/store/app.reducer';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import * as SiteActions from 'src/app/store/site/site.actions';
import { ActivatedRoute } from '@angular/router';
import { LOCALSTORAGE_CURRENT_SITE_ID } from 'src/app/conf/user';
import { selectSites, selectSitesLoading } from 'src/app/store/site/site.selector';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-devices-list',
	templateUrl: './devices-list.component.html',
	providers: [ConfirmationService, DialogService]
})

export class DevicesListComponent implements OnInit, OnDestroy {
	loading$: Observable<boolean | undefined>;
	loadingSub: Subscription | undefined;
	sites$: Observable<Site[] | undefined>;
	sitesSub: Subscription | undefined;

	loading: boolean;
	sites: Site[];
	currentSiteId: number;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		public dialogService: DialogService,
		private route: ActivatedRoute,
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.subscribeAll();
		this.onResize();
	}

	getSiteIdUrlCookie(paramSiteId: string) {
		const lsSiteId = localStorage.getItem(LOCALSTORAGE_CURRENT_SITE_ID);
		if (paramSiteId) {
			this.currentSiteId = parseInt(paramSiteId, 10);
		} else if (lsSiteId) {
			this.currentSiteId = parseInt(lsSiteId, 10);
		}
	}

	initSelectors(): void {
		// Store selectors
		this.loading$ = this.store.select(selectSitesLoading);
		this.sites$ = this.store.select(selectSites);
	}

	subscribeAll(): void {
		this.route.queryParamMap.subscribe(params => {
			const paramSiteId = params.get('siteId');
			this.getSiteIdUrlCookie(paramSiteId);
			this.store.dispatch(SiteActions.setCurrentSite({ siteId: this.currentSiteId }));
		});
		this.sitesSub = this.sites$.subscribe(() => {
			this.getSiteIdUrlCookie(null);
			this.store.dispatch(SiteActions.setCurrentSite({ siteId: this.currentSiteId }));
		});
		this.loadingSub = this.loading$?.subscribe(
			(loading) => {
				this.loading = loading;
			}
		);
		this.sitesSub = this.sites$?.subscribe(
			(sites) => {
				this.sites = sites;
			}
		);
	}

	ngOnDestroy(): void {
		this.loadingSub?.unsubscribe();
		this.sitesSub?.unsubscribe();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive() {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}
}
